import React, { useState } from 'react';
import styled from 'styled-components';
import Spinner from '../../../app/common/components/Spinner';
import { useDispatch } from 'react-redux';
import AccountSecurityActions from '../accountSecurityActions';
import { Link, LinkWrapper } from './VerifyEmailForm';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { AccountSecurityFormType } from '../AccountSecurity';

const SpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25vh;
`;
const StrongText = styled.strong`
    font-weight: 700;
`;
const PromptWrapper = styled.div`
    margin: 24px auto;
    line-height: 1.5em;
`;
interface ISendOtpFailedOverlay {
    sendOtpTimes: number;
    email: string;
    sendOtpAgain: () => void;
}

const SendOtpFailedOverlay: React.FC<ISendOtpFailedOverlay> = ({
    sendOtpTimes,
    email,
    sendOtpAgain,
}) => {
    const [fakeLoading, setFakeLoading] = useState(false);
    const dispatch = useDispatch();

    const onSendOtpAgain = () => {
        setFakeLoading(true);
        setTimeout(() => {
            sendOtpAgain();
            setFakeLoading(false);
        }, 200);
    };

    const onEditEmail = () => {
        dispatch(
            AccountSecurityActions.changeAccountSecurityOverlay(AccountSecurityFormType.EMAIL),
        );
    };

    return (
        <>
            {fakeLoading ? (
                <SpinnerWrapper>
                    <Spinner />
                </SpinnerWrapper>
            ) : (
                <>
                    <PromptWrapper>
                        {sendOtpTimes < 6
                            ? TranslationHelpers.getFormattedMessage('email.verify.sendFailed', {
                                  br: <br />,
                                  email: <StrongText>{email}</StrongText>,
                              })
                            : TranslationHelpers.getFormattedMessage(
                                  'email.verify.sendFailedLimit',
                                  {
                                      email: <StrongText>{email}</StrongText>,
                                  },
                              )}
                    </PromptWrapper>
                    {sendOtpTimes < 6 && (
                        <>
                            <LinkWrapper>
                                <Link onClick={onEditEmail}>
                                    {TranslationHelpers.getFormattedMessage(
                                        'email.verify.editEmail',
                                    )}
                                </Link>
                            </LinkWrapper>
                            <LinkWrapper>
                                <Link onClick={onSendOtpAgain}>
                                    {TranslationHelpers.getFormattedMessage(
                                        'email.verify.sendCodeAfterFailed',
                                    )}
                                </Link>
                            </LinkWrapper>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default SendOtpFailedOverlay;
